import {ActionConfig} from '../../../Components/TableButtonsActions/TableButtonsActions';
import {Transaction} from '../../../types/TypesUserAccounts';

export const getAvailableActions = (
	tx: Transaction,
	allActions: ActionConfig[],
): ActionConfig[] => {
	const {type, status} = tx;

	switch (type) {
		case 'conversion':
			if (status !== 'rejected') {
				return allActions.filter((a) => a.type === 'reject');
			}
			break;

		case 'withdrawal':
			if (status === 'paid') {
				return allActions.filter((a) => a.type === 'receive');
			}
			if (status === 'new') {
				return allActions.filter((a) => a.type === 'reject');
			}
			break;

		case 'transfer-in':
			if (status === 'new') {
				return allActions.filter((a) => ['approve', 'reject'].includes(a.type));
			}
			if (status === 'approved') {
				return allActions.filter((a) => ['reject', 'confirm'].includes(a.type));
			}
			break;

		case 'transfer-out':
			if (status === 'new') {
				return allActions.filter((a) => a.type === 'reject');
			}
			if (status === 'paid') {
				return allActions.filter((a) => a.type === 'receive');
			}
			break;
	}

	// по умолчанию ничего
	return [];
};
